import { removeDuplicacyById } from "../../utils/Utils";
import * as actionTypes from "../ActionTypes";

const INITIAL = {
  categories: [],
  videos: [],
  curriculum: [],
  testimonials: [],
  journals: [],
  isMobile: false,
  globalBibleSearchResults: [],
  globalVideoSearchResults: [],
  globalTestimonySearchResults: [],
  globalPromiseSearchResults: [],
  globalJournalSearchResults: [],
  globalCurriculumSearchResults: [],
  globalCategoriesSearchResults: [],
};

const commonReducer = (state = INITIAL, action) => {
  let newValues = null;
  switch (action.type) {
    case actionTypes.SET_GLOBAL_CATEGORY:
      return {
        ...state,
        categories: action.payload,
      };

    case actionTypes.ADD_GLOBAL_CATEGORY:
      newValues = removeDuplicacyById([...state.categories, ...action.payload]);
      return {
        ...state,
        categories: newValues,
      };

    case actionTypes.SET_GLOBAL_CURRICULUM:
      return {
        ...state,
        curriculum: action.payload,
      };

    case actionTypes.ADD_GLOBAL_CURRICULUM:
      newValues = removeDuplicacyById([...state.curriculum, ...action.payload]);
      return {
        ...state,
        curriculum: newValues,
      };

    case actionTypes.SET_GLOBAL_VIDEOS:
      return {
        ...state,
        videos: action.payload,
      };

    case actionTypes.ADD_GLOBAL_VIDEOS:
      newValues = removeDuplicacyById([...state.videos, ...action.payload]);
      return {
        ...state,
        videos: newValues,
      };

    case actionTypes.SET_GLOBAL_TESTIMONIALS:
      return {
        ...state,
        testimonials: action.payload,
      };

    case actionTypes.ADD_GLOBAL_TESTIMONIALS:
      newValues = removeDuplicacyById([...state.testimonials, ...action.payload]);
      return {
        ...state,
        testimonials: newValues,
      };

    case actionTypes.ADD_GLOBAL_JOURNALS:
      console.log("action.payload", action.payload);
      console.log("state.journals", state.journals);
      newValues = removeDuplicacyById([...state.journals, ...action.payload]);
      return {
        ...state,
        journals: newValues,
      };
    case actionTypes.SET_MOBILE_VIEW:
      return {
        ...state,
        isMobile: action.payload,
      };
    // Bible Search
    case actionTypes.SET_GLOBAL_BIBLE_SEARCH_RESULTS:
      return {
        ...state,
        globalBibleSearchResults: action.payload,
      };

    case actionTypes.ADD_GLOBAL_BIBLE_SEARCH_RESULTS:
      return {
        ...state,
        globalBibleSearchResults: [...state.globalBibleSearchResults, ...action.payload],
      };

    // Video Search
    case actionTypes.SET_GLOBAL_VIDEO_SEARCH_RESULTS:
      return {
        ...state,
        globalVideoSearchResults: action.payload,
      };

    case actionTypes.ADD_GLOBAL_VIDEO_SEARCH_RESULTS:
      return {
        ...state,
        globalVideoSearchResults: [...state.globalVideoSearchResults, ...action.payload],
      };

    // Testimony Search
    case actionTypes.SET_GLOBAL_TESTIMONY_SEARCH_RESULTS:
      return {
        ...state,
        globalTestimonySearchResults: action.payload,
      };

    case actionTypes.ADD_GLOBAL_TESTIMONY_SEARCH_RESULTS:
      return {
        ...state,
        globalTestimonySearchResults: [...state.globalTestimonySearchResults, ...action.payload],
      };

    // Promise Search
    case actionTypes.SET_GLOBAL_PROMISE_SEARCH_RESULTS:
      return {
        ...state,
        globalPromiseSearchResults: action.payload,
      };

    case actionTypes.ADD_GLOBAL_PROMISE_SEARCH_RESULTS:
      return {
        ...state,
        globalPromiseSearchResults: [...state.globalPromiseSearchResults, ...action.payload],
      };

    // Journal Search
    case actionTypes.SET_GLOBAL_JOURNAL_SEARCH_RESULTS:
      return {
        ...state,
        globalJournalSearchResults: action.payload,
      };

    case actionTypes.ADD_GLOBAL_JOURNAL_SEARCH_RESULTS:
      return {
        ...state,
        globalJournalSearchResults: [...state.globalJournalSearchResults, ...action.payload],
      };

    // Curriculum Search
    case actionTypes.SET_GLOBAL_CURRICULUM_SEARCH_RESULTS:
      return {
        ...state,
        globalCurriculumSearchResults: action.payload,
      };

    case actionTypes.ADD_GLOBAL_CURRICULUM_SEARCH_RESULTS:
      return {
        ...state,
        globalCurriculumSearchResults: [...state.globalCurriculumSearchResults, ...action.payload],
      };

    // Categories Search
    case actionTypes.SET_GLOBAL_CATEGORIES_SEARCH_RESULTS:
      return {
        ...state,
        globalCategoriesSearchResults: action.payload,
      };

    case actionTypes.ADD_GLOBAL_CATEGORIES_SEARCH_RESULTS:
      return {
        ...state,
        globalCategoriesSearchResults: [...state.globalCategoriesSearchResults, ...action.payload],
      };
    default:
      return state;
  }
};

export default commonReducer;
